import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "kpi-edit-save-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.KpiDocumentDesignerSaveDialogDescriptor.dialog.style,
    contentStyle: _ctx.KpiDocumentDesignerSaveDialogDescriptor.dialog.contentStyle,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.saveDialogTitle')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.close'),
        onClick: _ctx.close
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.save'),
        disabled: _ctx.saveButtonDisabled,
        onClick: _ctx.saveKpi
      }, null, 8, ["label", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", null, [
        _createVNode("h2", null, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.saveTitle')), 1),
        _createVNode("h4", null, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.saveSubheader')), 1),
        _createVNode("div", _hoisted_1, [
          _createVNode("span", _hoisted_2, [
            _createVNode(_component_InputText, {
              class: ["kn-material-input", {
                            'p-invalid': _ctx.kpiName.length === 0
                        }],
              modelValue: _ctx.kpiName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.kpiName = $event))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.kpiName')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["style", "contentStyle", "visible"]))
}